import React from "react";
import { motion } from "framer-motion";

export default function About() {
  return (
    <section id="about" className="section relative bg-[#F7F5F0]" data-testid="about-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-3">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6 }}
              className="overline mb-6"
            >
              [04] / About Us
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="hidden lg:block"
            >
              <div className="font-mono text-xs text-black/40 leading-loose mt-12 space-y-2">
                <div>برق</div>
                <div>↓</div>
                <div>BARRAQ</div>
                <div>↓</div>
                <div>BURAQ</div>
              </div>
            </motion.div>
          </div>

          <div className="lg:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8 }}
              className="font-display text-4xl md:text-5xl lg:text-7xl leading-[1] tracking-tighter mb-12 text-[#0A0A0A]"
              data-testid="about-headline"
            >
              Barq is <span className="italic font-light">lightning</span>.
              <br />
              <span className="text-[#C99B1A]">Barraq</span> is{" "}
              <span className="italic font-light">brilliant</span> lightning —
              <br />
              radiant, dazzling, illuminated by superior logic.
            </motion.h2>

            <div className="grid md:grid-cols-2 gap-12 mt-16 max-w-4xl">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
              >
                <div className="overline mb-4">Etymology</div>
                <p className="text-black/65 leading-relaxed">
                  In Arabic, <span className="text-[#0A0A0A] font-medium">Barq (برق)</span> means lightning. Its
                  intensive form, <span className="text-[#0A0A0A] font-medium">Barraq</span>, means brilliant,
                  radiant, dazzling. It shares its root with <span className="text-[#0A0A0A] font-medium">Buraq</span>{" "}
                  — the legendary creature said to travel as far as its eye can see in a single stride.
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.35 }}
              >
                <div className="overline mb-4">Promise</div>
                <p className="text-black/65 leading-relaxed">
                  We don't sell speed. We engineer brilliance. Our AI doesn't just respond — it{" "}
                  <span className="text-[#0A0A0A] font-medium">illuminates</span>. Every system we ship is a
                  single-stride leap for the teams who run them.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
